import { useEffect, useState } from "react";

import BuildingSkyscraper from "@assets/icons/building-skyscraper.svg";

import { APP_COLORS } from "@styles/colors";
import { cn } from "@utils/tailwind.util";
import { normalizeLogoUrl } from "@utils/logo.util";
import { ICompany } from "@interfaces/company.interface";

interface ICompanyIconBadgeProps {
  url?: string | null;
  size?: "SMALL" | "MEDIUM";
  overrideIcon?: React.ReactNode;
  className?: string;
  logoClassName?: string;
}

const sizeParams = {
  SMALL: {
    className: "h-5 w-5 rounded",
    iconSize: 14,
  },
  MEDIUM: {
    className: "h-9 w-9 rounded-lg",
    iconSize: 19,
  },
};

export function CompanyIconBadge({
  url: rawUrl,
  size = "SMALL",
  overrideIcon,
  className,
  logoClassName,
}: ICompanyIconBadgeProps) {
  // TODO: remove normalizeLogoUrl once the Scout Agent index is
  // re-built with the new URL format from BE.
  const url = normalizeLogoUrl(rawUrl);
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [url]);

  const hasValidLogo = Boolean(url && url.length > 0 && !imageFailed);

  return (
    <div
      className={cn(
        "relative flex flex-shrink-0 items-center justify-center overflow-hidden border border-gray-200",
        sizeParams[size].className,
        {
          "bg-white": hasValidLogo,
          "bg-background-secondary": !hasValidLogo,
        },
        className
      )}
    >
      {hasValidLogo ? (
        <img
          src={url as string}
          alt=""
          className={cn("absolute inset-0 h-full w-full object-cover", logoClassName)}
          onError={() => setImageFailed(true)}
        />
      ) : (
        overrideIcon || (
          <BuildingSkyscraper
            width={sizeParams[size].iconSize}
            height={sizeParams[size].iconSize}
            className="flex-shrink-0"
            color={APP_COLORS.content.primaryOpacity70}
          />
        )
      )}
    </div>
  );
}

export const CompanyIconBadgeComponentForCompany = ({ company }: { company: ICompany }) => {
  return <CompanyIconBadge url={company.logo_url} size="SMALL" />;
};
